export const SDK_VERSION = '7.38.0';
